import { Modal } from 'bootstrap';

export default function initSubscribeModal () {
    const form = document.getElementById('subscribeForm');
    const modalElement = document.getElementById('successModal');

    if (!form || !modalElement) return;

    const emailInput = form.querySelector('input[type="email"]');
    if (!emailInput) return;

    const successModal = new Modal(modalElement);

    form.addEventListener('submit', function (e) {
        e.preventDefault();

        const email = emailInput.value.trim();
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        emailInput.classList.remove('is-invalid');

        if (email === '' || !isValidEmail) {
            emailInput.classList.add('is-invalid');
            return;
        }

        successModal.show();
        form.reset();
    });
}
